import { Component, Input } from "@angular/core";
import { UserCollectionImportTaskStatus } from "@apiserver-rest/ponder-tasks-client-base";
import { FormatDateTimePipe } from "@ponder-shared/pipes/format-datetime.pipe";
import { ColorDictionary } from "@ponder-shared/utils/colors";

@Component({
    selector: "import-collection-result-row",
    imports: [FormatDateTimePipe],
    templateUrl: "./import-collection-result-row.component.html"
})
export class ImportCollectionResultRowComponent {
    @Input({ required: true }) result!: UserCollectionImportTaskStatus;
    
    public showDetails: boolean = true;

    public readonly ColorPending = ColorDictionary.StatusBlue;
    public readonly ColorSuccess = ColorDictionary.StatusGreen;
    public readonly ColorFailed = ColorDictionary.StatusRed;

    public constructor() {

    }

    public onShowDetailsClicked() {
        if (this.showDetails) {
            this.onHideDetails();
        } else {
            this.onShowDetails();
        }
    }

    private onHideDetails() {
        this.showDetails = false;
    }

    private onShowDetails() {
        this.showDetails = true;
    }
}